const initialState = {
    isOpen: false,
    stage: '',
    message: '',
    percent: null,
}

const firmwareAssetsUpdateReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FIRMWARE_ASSETS_UPDATE_PROGRESS':
            // The payload contains the new state for the modal
            return {
                ...state,
                ...action.payload,
            }

        // It's good practice to have a way to reset the state
        case 'HIDE_FIRMWARE_ASSETS_UPDATE':
            return initialState

        default:
            return state
    }
}

export default firmwareAssetsUpdateReducer
